import { render } from "./CustomTopicModelEditorNewTheme.vue?vue&type=template&id=0e320240"
import script from "./CustomTopicModelEditorNewTheme.vue?vue&type=script&lang=js"
export * from "./CustomTopicModelEditorNewTheme.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__